<template>
  <div id="app">
    <Header v-show="showGlobeHeader() === -1" />
    <keep-alive :include="keepAliveRouteNames">
      <router-view class="app-content" v-if="isReloadAlive" />
    </keep-alive>
    <Login v-if="showLogin" />
    <GoTop v-if="showSideOfRightMenu" />
    <LiveLogout />
    <LoadingSpinner :visible="routeLoading || initialLoading" />
    <el-dialog
      :visible.sync="dialogVisible"
      width="532px"
      top="20vh"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="!showMaintenance"
      :destroy-on-close="true"
      custom-class="maintenance-dialog"
      @close="closeDialog"
    >
      <div class="maintenance">
        <img class="maintenance-logo" :src="require('./assets/img/maint.png')" alt="" />
        <h3 class="text-title">{{ maintain.title }}</h3>
        <div>
          <p class="content-text" style="max-height: 20vh; overflow-y: scroll">{{ maintain.content }}</p>
          <p class="maintenance-time">
            维护时间:
            <span style="color: #0dc286"> {{ format(maintain.start_time * 1000, "yyyy年MM月dd日hh:mm") }}～{{ format(maintain.end_time * 1000, "yyyy年MM月dd日hh:mm") }} </span>
          </p>
          <el-button class="maintenance-btn" v-if="!showMaintenance" @click="closeDialog">我已知晓</el-button>
        </div>
      </div>
    </el-dialog>
    <Checkin ref="checkin" v-if="appConfig?.checkin_switch" />
    <TicketPayConfirm v-if="ticketPayDialog" />
    <div class="toast-tips" v-show="toastText">{{ toastText }}</div>
  </div>
</template>
<script>
// @ is an alias to /src
import { post } from "@/util/http";
import Header from "@/components/header/header.vue";
import LoadingSpinner from "@/components/loading/LoadingSpinner.vue";
import { mapMutations, mapState, mapActions } from "vuex";
import { format } from "@/util/time";
import { initTim, routeNeedsTim } from "@/util/tim";
import { isSpecialLandingDownloadHost } from "@/util/lm-download";

export default {
  components: {
    Header,
    LoadingSpinner,
    // 非首屏必需组件懒加载，减小 app 初始包
    Login: () => import(/* webpackChunkName: "comp-login" */ "@/components/login/login.vue"),
    GoTop: () => import(/* webpackChunkName: "comp-gotop" */ "@/components/go-top/go-top.vue"),
    LiveLogout: () => import(/* webpackChunkName: "comp-live-logout" */ "@/components/live-logout/live-logout.vue"),
    Checkin: () => import(/* webpackChunkName: "comp-checkin" */ "@/components/checkin/checkin.vue"),
    TicketPayConfirm: () => import(/* webpackChunkName: "comp-ticket-pay" */ "@/components/dialog/TicketPayConfirm"),
  },
  provide() {
    // 实现页面刷新
    return {
      reload: this.reload,
    };
  },
  computed: {
    ...mapState(["userInfo", "toast", "isTimReady", "routeLoading", "showLogin", "ticketPayDialog"]),
    showSideOfRightMenu() {
      // return this.$route.path === '/home';
      return ["home", "scheduleDetail"].includes(this.$route.name);
    },
    showMaintenance() {
      const now = Date.now();
      return now >= this.maintain.start_time * 1000 && now <= this.maintain.end_time * 1000;
    },
  },
  data() {
    return {
      // 从赛程进入详情/直播间后返回，保留世界杯页列表与滚动位置
      keepAliveRouteNames: ["worldCup"],
      isReloadAlive: true,
      maintain: {},
      dialogVisible: false,
      toastTime: null,
      toastText: "",
      appConfig: {},
      // 页面初次加载状态
      initialLoading: true,
    };
  },
  watch: {
    $route(to, from) {
      console.log("$route to==>", to.path);
      console.log("$route from==>", from.path);
      if (this.shouldRefreshCommonConfig(to, from)) {
        this.getCommonConfig(this.getCommonConfigAnchor(to));
      }
    },
    toast(newVal) {
      if (this.toastTime) {
        clearTimeout(this.toastTime);
      }
      this.toastText = newVal[newVal.length - 1];
      this.toastTime = setTimeout(() => {
        this.toastText = "";
      }, 1500);
    },
  },
  async mounted() {
    this.showGlobeHeader();
    this.getCommonConfig(this.getCommonConfigAnchor(this.$route));
    // this.getMaintenanceOfLoop();
    // this.getChatConfig();
    // this.getGiftList();
    // this.preloadVipSource();
    // if (document.cookie.indexOf("checkin=") === -1) {
    //   this.setcookie();
    //   this.toggleCheckinDialog(true);
    // }
    if (this.userInfo.id) {
      this.getUserBackpack();
      this.getChatList();
    }

    // 首屏 loading：不要等 window.load（图片/媒体会拖慢），但也不能在首个路由未 ready 时提前关闭，
    // 否则会出现“先出页面 → 又出现 loading → 再出页面”的闪烁。
    const hideInitialLoading = () => {
      if (!this.initialLoading) return;
      this.initialLoading = false;
    };

    const hideAfterFirstRouteReady = () => {
      this.$nextTick(() => {
        if (typeof requestAnimationFrame === "function") {
          requestAnimationFrame(() => hideInitialLoading());
        } else {
          hideInitialLoading();
        }
      });
    };

    // 等待首个路由解析完成（含重定向、懒加载 chunk）
    if (this.$router && typeof this.$router.onReady === "function") {
      this.$router.onReady(hideAfterFirstRouteReady);
    } else {
      setTimeout(hideAfterFirstRouteReady, 0);
    }

    // 兜底：避免异常情况下常驻
    setTimeout(hideInitialLoading, 2500);
  },
  created() {
    // document.addEventListener("visibilitychange", this.changeBrowserTab, false); //被踢出重新登录TIM
    // let token = localStorage.getItem("token");
    // let id = localStorage.getItem("id");
    // let userInfo = localStorage.getItem("userInfo");
    // localStorage.clear();
    // localStorage.setItem("userInfo", userInfo);
    // localStorage.setItem("token", token);
    // localStorage.setItem("id", id);
    localStorage.setItem("language", LOCALE);
    // if (!localStorage.getItem("language")) {
    //   localStorage.setItem("language", LOCALE);
    // }
    this.maintainTimer = null;
  },
  methods: {
    ...mapMutations(["changeConfig", "updateGifts", "toggleCheckinDialog", "changeUserInfo"]),
    ...mapActions(["getChatConfig", "getUserBackpack", "getChatList"]),
    format,
    showGlobeHeader() {
      const pathName = this.$route.name;
      if (pathName === "download" && isSpecialLandingDownloadHost()) {
        return 0;
      }
      console.log("path---------", pathName, ["liveMatches", "liveMatchesTwo"].indexOf(pathName));
      // return ["liveMatches", "liveMatchesTwo", "privacy"].indexOf(pathName);
      return ["privacy", "protocol"].indexOf(pathName);
    },
    getCommonConfigAnchor(route = this.$route) {
      if (!["liveMatchesTwo", "anchorReplay"].includes(route.name)) {
        return "";
      }

      return route.params?.id || "";
    },
    shouldRefreshCommonConfig(to, from) {
      if (to.name === "privateChat" && from.name !== "privateChat") {
        return true;
      }

      if (!["liveMatchesTwo", "anchorReplay"].includes(to.name)) {
        return false;
      }

      return from.name !== to.name || to.params?.id !== from.params?.id;
    },
    changeBrowserTab(event) {
      // console.log("切换TAB：：：：：：：：：：：：：：：：", this.isTimReady, document.visibilityState);
      if (document.visibilityState === "visible" && !this.isTimReady) {
        if (localStorage.getItem("userInfo")) {
          this.changeUserInfo(JSON.parse(localStorage.getItem("userInfo")));
          this.getUserBackpack();
        } else {
          this.changeUserInfo({});
        }
        // 仅 IM 相关页才重登，避免首页切回标签页就抬高 IM DAU
        if (routeNeedsTim(this.$route)) {
          initTim();
        }
      }
    },
    setcookie() {
      // let d = new Date();
      // d.setTime(d.getTime() + 24 * 60 * 60 * 1000); //24小时
      // console.log("date-------------", new Date(new Date().setUTCHours(24, 0, 0, 0)));
      localStorage.setItem("popup1", "0");
      // document.cookie = "checkin=popup-checkin;expires= " + d.toGMTString();
      // document.cookie = "checkin=popup-checkin;expires= " + new Date(new Date(new Date().getTime() + 24 * 60 * 60 * 1000).setHours(0, 0, 0, 0)).toUTCString();
      document.cookie = "checkin=popup-checkin;expires= " + new Date(new Date().setHours(24, 0, 0, 0)).toUTCString();
      let result = document.cookie;
      return result;
    },
    closeDialog() {
      localStorage.setItem("close_m", Date.now().toString());
      this.dialogVisible = false;
    },

    getMaintenanceOfLoop() {
      if (this.maintainTimer) {
        clearTimeout(this.maintainTimer);
        this.maintainTimer = null;
      }
      // 1 pc 2 h5 3 android 4 ios
      post({
        url: "/api/maintain",
        data: {
          device: 1,
        },
      })
        .then((result) => {
          if (result.status === 200) {
            const res = result.data || {};
            if (res.status === 0) {
              const maintain = res.data;
              // 有值出现弹框
              if (maintain) {
                this.maintain = maintain;
                // 6小时内弹出过 不再提醒
                const now = Date.now();
                const lastCloseTime = Number(localStorage.getItem("close_m") || 0);
                // 距离上次关闭的时间 小于6小时，当前时间 小于维护起始时间
                const { remind_time, start_time, end_time } = maintain;
                const remindFlag = now - lastCloseTime > 6 * 60 * 60 * 1000 && remind_time > 0 && remind_time < start_time && now < start_time * 1000 && now >= remind_time * 1000;
                const maintFlag = now >= start_time * 1000 && now <= end_time * 1000;
                this.dialogVisible = remindFlag || maintFlag;
              } else {
                this.dialogVisible = false;
              }
            }
          }
        })
        .finally(() => {
          this.maintainTimer = setTimeout(() => {
            this.getMaintenanceOfLoop();
          }, 60000);
        });
    },

    reload() {
      this.isReloadAlive = false;
      this.$nextTick(() => {
        this.isReloadAlive = true;
      });
    },
    async getCommonConfig(anchor) {
      const header = anchor ? { anchor } : undefined;
      const {
        data: {
          data: { config, live_category, chips },
        },
      } = await post({
        url: "/api/config/getCommonConfig",
        header,
      });
      this.appConfig = config;
      this.changeConfig(config);
      this.$store.commit("changeChips", chips);
      let oldCountTimes = localStorage.getItem("count_times_today") || 0;
      sessionStorage.setItem("preview_switch", config.live_preview_switch);
      // 首页/列表不登录 IM；直播间、私聊等路由再登录（页面内也会按需 initTim）
      if (routeNeedsTim(this.$route)) {
        initTim();
      }

      if (document.cookie.indexOf("checkin=") === -1 || oldCountTimes != config.dialog_daily_times) {
        this.setcookie();
        this.toggleCheckinDialog(true);
        localStorage.setItem("count_times", config.dialog_daily_times);
        localStorage.setItem("count_times_today", config.dialog_daily_times);
        // localStorage.setItem("count_times", "3");
      }
    },

    // async getGiftList() {
    //   post({
    //     url: "/api/gift/getGiftList",
    //   })
    //     .then((result) => {
    //       if (result.status === 200) {
    //         const res = result.data || {};

    //         console.log("getGiftList post", res);
    //         if (res.status === 0) {
    //           const giftList = res.data || [];

    //           giftList.forEach((item) => {
    //             const key = `gift_${item.id}`;
    //             this.updateGifts({
    //               key,
    //               data: {
    //                 ...item,
    //                 loaded: false,
    //               },
    //             });

    //             if (/\.svga$/.test(item.animation)) {
    //               this.preloadSvgSource({
    //                 key,
    //                 source_url: item.animation,
    //               })
    //                 .then(() => {
    //                   console.log(`gift:${key}加载完成！！！`);
    //                   this.updateGifts({
    //                     key,
    //                     data: {
    //                       loaded: true,
    //                     },
    //                   });
    //                 })
    //                 .catch((err) => console.log(err));
    //             }
    //           });
    //         }
    //       }
    //     })
    //     .catch((err) => console.log(err));
    // },
  },
};
</script>
<style lang="scss">
@import "assets/common.scss";
@import "assets/common-message.scss";

.toast-tips {
  padding: 0.1rem 0.26rem;
  font-size: 0.16rem;
  color: #ffffff;
  font-weight: 500;
  line-height: 0.2rem;
  background: rgba(0, 0, 0, 0.6);
  border-radius: 0.44rem;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 100;
}

#app {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.app-content {
  flex: 1;
}

.maintenance-dialog {
  padding: 0;
  border-radius: 20px;

  .el-dialog__header,
  .el-dialog__body {
    padding: 0;
  }
}

.maintenance {
  background: linear-gradient(158.56deg, #e3faff 0%, #ffffff 42.59%);
  box-shadow: 0 0 2px rgba(0, 0, 0, 0.05);
  border-radius: 20px;
  width: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0 0.5rem 0.32rem 0.5rem;

  .maintenance-logo {
    width: 134px;
    height: 116px;
    margin-top: 32px;
  }

  .content-text {
    font-size: 0.16rem;
    line-height: 0.2rem;
  }

  .text-title {
    font-size: 0.24rem;
    line-height: 0.26rem;
    color: rgba(0, 0, 0, 0.8);
    margin: 0.16rem 0 0.2rem 0;
  }

  .maintenance-time {
    color: #666;
    font-size: 16px;
    margin-top: 0.1rem;
  }

  .maintenance-btn {
    display: block;
    padding: 0;
    width: 220px;
    font-size: 0.16rem;
    height: 48px;
    color: #fff;
    background: var(--theme-gradient);
    box-shadow: 0 4px 8px rgba(48, 185, 188, 0.2);
    border-radius: 6px;
    border: none;
    margin: 0.32rem auto 0;
  }
}

.el-dialog__headerbtn .el-dialog__close {
  color: #bfd1d0;
  font-size: 20px;
  font-weight: 700;
}
</style>
